import { render, staticRenderFns } from "./CevaTheoremViz.vue?vue&type=template&id=28a468f3&scoped=true"
import script from "./CevaTheoremViz.vue?vue&type=script&lang=js"
export * from "./CevaTheoremViz.vue?vue&type=script&lang=js"
import style0 from "./CevaTheoremViz.vue?vue&type=style&index=0&id=28a468f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a468f3",
  null
  
)

export default component.exports